import Layout from '@/layout'

const route = {
  path: '/materialReport',
  component: Layout,
  redirect: '/materialReport/index',
  alwaysShow: true, // will always show the root menu
  name: 'materialReport',
  meta: {
    title: '素材报表',
    icon: 'MRM',
    roles: [
      'material_report.manage'
    ]
  },
  children: [
    {
      path: '/massiveAdvertising/index',
      name: 'massiveAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '腾讯广告',
        roles: [
          'material_report.manage.adq'
        ]
      },
      children: [
        // {
        //   path: '/materialReport/releaseGroupList/index',
        //   component: () => import('@/views/materialReport/releaseGroupList/index.vue'),
        //   name: 'releaseGroupList',
        //   meta: {
        //     title: '投放组列表',
        //     icon: 'component',
        //     roles: [
        //       'material_bind_groups.index'
        //     ]
        //   }
        // },
        // {
        //   path: '/materialReport/bindingRelationList/index',
        //   component: () => import('@/views/materialReport/bindingRelationList/index.vue'),
        //   name: 'bindingRelationList',
        //   meta: {
        //     title: '绑定关系列表',
        //     icon: 'component',
        //     roles: [
        //       'material_bind_relations.index'
        //     ]
        //   }
        // },
        {
          path: '/materialReport/reportList/index',
          component: () => import('@/views/materialReport/reportList/index.vue'),
          name: 'reportList',
          meta: {
            title: '报表列表',
            icon: 'component',
            roles: [
              'material_report.report_list'
            ]
          }
        }, {
          path: '/materialReport/totalReportList/index',
          component: () => import('@/views/materialReport/totalReportList/index.vue'),
          name: 'totalReportList',
          meta: {
            title: '总计报表',
            icon: 'component',
            roles: [
              'material_report.total_report'
            ]
          }
        }, {
          path: '/materialReport/materialDetails/index',
          component: () => import('@/views/materialReport/materialDetails/index.vue'),
          name: 'materialDetails',
          meta: {
            title: '素材明细',
            icon: 'component',
            roles: [
              'material_report.material_details'
            ]
          }
        }
      ] },
    {
      path: '/tencentAdvertising/index',
      name: 'tencentAdvertising',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      meta: {
        title: '巨量广告',
        roles: [
          'material_report.manage.ocean'
        ]
      },
      children: [
        // {
        //   path: '/tencentAdvertising/releaseGroupList/index',
        //   component: () => import('@/views/enormousAmountMaterialReport/releaseGroupList/index.vue'),
        //   name: 'releaseGroupList',
        //   meta: {
        //     title: '投放组列表',
        //     icon: 'component',
        //     roles: [
        //       'ocean_material_bind_groups.index'
        //     ]
        //   }
        // },
        // {
        //   path: '/tencentAdvertising/bindingRelationList/index',
        //   component: () => import('@/views/enormousAmountMaterialReport/bindingRelationList/index.vue'),
        //   name: 'bindingRelationList',
        //   meta: {
        //     title: '绑定关系列表',
        //     icon: 'component',
        //     roles: [
        //       'ocean_material_bind_relations.index'
        //     ]
        //   }
        // },
        {
          path: '/tencentAdvertising/reportList/index',
          component: () => import('@/views/enormousAmountMaterialReport/reportList/index.vue'),
          name: 'reportList',
          meta: {
            title: '报表列表',
            icon: 'component',
            roles: [
              'ocean_material_report.report_list'
            ]
          }
        }, {
          path: '/tencentAdvertising/totalReportList/index',
          component: () => import('@/views/enormousAmountMaterialReport/totalReportList/index.vue'),
          name: 'totalReportList',
          meta: {
            title: '总计报表',
            icon: 'component',
            roles: [
              'ocean_material_report.total_report'
            ]
          }
        }, {
          path: '/tencentAdvertising/materialDetails/index',
          component: () => import('@/views/enormousAmountMaterialReport/materialDetails/index.vue'),
          name: 'materialDetails',
          meta: {
            title: '素材明细',
            icon: 'component',
            roles: [
              'ocean_material_report.material_details'
            ]
          }
        }
      ] },
    {
      path: '/tencentAdvertising/releaseGroupList/index',
      component: () => import('@/views/enormousAmountMaterialReport/releaseGroupList/index.vue'),
      name: 'releaseGroupList',
      meta: {
        title: '投放组列表',
        icon: 'component',
        roles: [
          'ocean_material_bind_groups.index'
        ]
      }
    },
    {
      path: '/tencentAdvertising/bindingRelationList/index',
      component: () => import('@/views/enormousAmountMaterialReport/bindingRelationList/index.vue'),
      name: 'bindingRelationList',
      meta: {
        title: '绑定关系列表',
        icon: 'component',
        roles: [
          'ocean_material_bind_relations.index'
        ]
      }
    },
    {
      path: '/materialReport/adCollect/index',
      component: () => import('@/views/materialReport/adCollect/index.vue'),
      name: 'adCollect',
      meta: {
        title: '广告明细汇总',
        icon: 'component',
        roles: [
          'history_summary'
        ]
      }
    }, {
      path: '/materialReport/maxCost/index',
      component: () => import('@/views/materialReport/maxCost/index.vue'),
      name: 'maxCost',
      meta: {
        title: '高量素材',
        icon: 'component',
        roles: [
          'history_summary'
        ]
      }
    }, {
      path: '/materialReport/materialEngineer/index',
      component: () => import('@/views/materialReport/materialEngineer/index.vue'),
      name: 'materialEngineer',
      meta: {
        title: '素材师高量统计',
        icon: 'component',
        roles: [
          'history_summary.video_material_bind'
        ]
      }
    }

  ]
}
export default route
